module.exports = __webpack_public_path__ + "img/g1.376ef92c.png";